export default {
  products: []
}
